export default {
  products: []
}
